export default "__VITE_ASSET__BEHXV_Y___"